<template>
  <div>
    <v-dialog width="500px" v-model="AnyCarDetailsDialog" persistent>
      <v-card color="white">
        <v-toolbar
          dense
          color="blueColorVariant9"
          class="white--text elevation-0"
          >Vehicle Details<v-spacer /><v-btn icon @click="AnyCarDialogEmit(1)"
            ><v-icon small color="white">mdi-close</v-icon></v-btn
          ></v-toolbar
        >
        <div align="center" class="mt-5" v-if="CarsArray.length > 1">
          <span class="blueColorVariant9--text">{{ UserName }}</span> have
          {{ CarsArray.length }} Vehicle, Click on License number to view
          details
        </div>
        <div v-else align="center" class="mt-5">
          Click on License number to view
          <span class="blueColorVariant9--text">{{ UserName }}</span> details
        </div>
        <div v-for="(item, index) in CarsArray" :key="index" align="center">
          <v-btn
            depressed
            dark
            color="blueColorVariant9"
            class="ma-3"
            @click="AnyCarDialogEmit(2, item.license_plate_number)"
            >{{ item.license_plate_number }}</v-btn
          >
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    AnyCarDetailsDialog: Boolean,
    CarsArray: Array,
    UserName: String,
  },

  methods: {
    AnyCarDialogEmit(Toggle, item) {
      this.$emit("clicked", Toggle, item);
    },
  },
};
</script>
